import {default as React} from 'react';
import {Redirect, RouteComponentProps} from 'react-router';
import CustomerList from './customers/CustomerList';
import EditCustomer from './customers/EditCustomer';
import NewCustomer from './customers/NewCustomer';
import Features from './features/Features';
import HandheldList from './handhelds/HandheldList';
import UpdateHandheld from './handhelds/UpdateHandheld';
import EditHub from './hubs/EditHub';
import HubList from './hubs/HubList';
import NewHub from './hubs/NewHub';

export interface AppRoute {
  path: string;
  exact?: boolean;
  component: React.ComponentType<RouteComponentProps<any>> | React.ComponentType<any>;
}

export type AppRoutes = AppRoute[];

export const routes: AppRoutes = [
  {
    component: Features,
    path: '/features'
  },
  {
    component: NewCustomer,
    path: '/customers/new'
  },
  {
    component: EditCustomer,
    path: '/customers/:customerId'
  },
  {
    component: CustomerList,
    path: '/customers'
  },
  {
    component: HubList,
    path: '/customers/:customerId/hubs'
  },
  {
    component: HandheldList,
    path: '/customers/:customerId/handhelds'
  },
  {
    component: UpdateHandheld,
    path: '/customers/:customerId/handhelds/:handheldId'
  },
  {
    component: NewHub,
    path: '/hubs/new'
  },
  {
    component: HubList,
    path: '/hubs'
  },
  {
    component: EditHub,
    path: '/hubs/:hubId'
  },
  {
    component: EditHub,
    path: '/customers/:customerId/hubs/:hubId'
  },
  {
    component: () => <Redirect to="/customers"/>,
    path: '/'
  }
];
